import { ShowSnackBar } from "event-definitions"

export function errorSnackbar(message, options = {}) {
    console.error(message)
    ShowSnackBar.raiseLater(message, { variant: "error", ...options })
}
